export default function FilterCell() {}

FilterCell.prototype.init = function (params) {
    this.eGui = document.createElement('div');
    this.eGui.classList.add('w5-cell');
    const filterCell = document.createElement('div');
    filterCell.classList.add('w5-filter-cell');
    const filterInput = document.createElement('input');
    filterInput.classList.add('w5-filter-cell__input');

    filterInput.setAttribute('type', 'text');
    filterInput.style.width = params.width || '100%';
    if (params.placeholder) filterInput.placeholder = params.placeholder;

    const searchIconContainer = document.createElement('div');
    searchIconContainer.classList.add('w5-filter-cell__search-icon');
    searchIconContainer.innerHTML = searchIcon;
    filterCell.appendChild(searchIconContainer);

    filterCell.appendChild(filterInput);

    this.currentValue = null;
    this.eFilterInput = filterCell.querySelector('input');

    let that = this;
    function onInputBoxChanged() {
        if (that.eFilterInput.value === '') {
            params.parentFilterInstance(function (instance) {
                if (instance.onFloatingFilterChanged) {
                    instance.onFloatingFilterChanged(null, null);
                } else if (instance.onCustomFilterChanged) {
                    instance.onCustomFilterChanged(null);
                }
            });
            return;
        }

        that.currentValue = that.eFilterInput.value;
        params.parentFilterInstance(function (instance) {
            if (instance.onFloatingFilterChanged) {
                instance.onFloatingFilterChanged('contains', that.currentValue);
            } else if (instance.onCustomFilterChanged) {
                instance.onCustomFilterChanged(that.currentValue);
            }
        });
    }
    this.eFilterInput.addEventListener('input', onInputBoxChanged);
    this.eGui.appendChild(filterCell);
};

FilterCell.prototype.onParentModelChanged = function (parentModel) {
    if (!parentModel) {
        this.eFilterInput.value = '';
        this.currentValue = null;
    } else {
        this.eFilterInput.value = parentModel.filter + '';
        this.currentValue = parentModel.filter;
    }
};

FilterCell.prototype.getGui = function () {
    return this.eGui;
};

const searchIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M12.208 13.338a7.5 7.5 0 111.13-1.13l.028.026 4.4 4.4a.8.8 0 11-1.132 1.132l-4.4-4.4a.813.813 0 01-.026-.028zM7.5 13a5.5 5.5 0 100-11 5.5 5.5 0 000 11z" fill="#B5BDC5" fill-rule="nonzero"/></svg>`;
